import classNames from 'classnames';
import React, { useContext } from 'react';
import { MyContext } from '@/config/context-manager';
import styles from './style.module.scss';

interface StepProps {
  lang: string[];
  className?: string;
}

const StepMobile = React.memo<StepProps>(({ lang, className }) => {
  const [step1, step2, step3, step4, step5, step6, step7] = lang.map((l) => l.split('\n'));
  const { locale } = useContext(MyContext);
  return (
    <>
      {locale === 'en' ? (
        <svg
          width="337"
          height="257"
          viewBox="0 0 337 257"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          className={classNames(styles.stepMobile, className)}
        >
          <ellipse cx="275.5" cy="249.5" rx="49.5" ry="7.5" fill="#A7DBEC" fillOpacity="0.17" />
          <path d="M13 28H280V40H13V28Z" fill="url(#paint0_linear)" />
          <text x="29" y="61" fill="#94D8FB">
            {step1[0]}
          </text>
          <text x="26" y="76" fill="#94D8FB">
            {step1[1]}
          </text>
          <g>
            <circle cx="49" cy="33" r="11" fill="white" />
            <circle cx="49" cy="33" r="10.5" stroke="#8CC6F9" />
          </g>
          <path
            d="M48.8906 28.004C48.5546 28.368 48.1346 28.69 47.6306 28.998C47.1266 29.278 46.6646 29.474 46.2166 29.586V31.098C47.1406 30.832 47.9106 30.412 48.5126 29.838V38H50.0386V28.004H48.8906Z"
            fill="#8CC6F9"
          />
          <text x="105" y="61" fill="#7A9FF6">
            {step2[0]}
          </text>
          <text x="102" y="76" fill="#7A9FF6">
            {step2[1]}
          </text>
          <text x="121" y="91" fill="#7A9FF6">
            {step2[2]}
          </text>
          <g>
            <circle cx="131" cy="33" r="11" fill="white" />
            <circle cx="131" cy="33" r="10.5" stroke="#799CF6" />
          </g>
          <path
            d="M130.657 27.808C129.593 27.808 128.725 28.158 128.081 28.886C127.451 29.558 127.129 30.454 127.115 31.574H128.641C128.669 30.762 128.837 30.16 129.173 29.74C129.495 29.306 129.971 29.096 130.601 29.096C131.189 29.096 131.651 29.236 131.959 29.516C132.267 29.796 132.421 30.216 132.421 30.776C132.421 31.364 132.183 31.91 131.735 32.414C131.455 32.708 130.979 33.086 130.307 33.562C129.173 34.346 128.417 34.948 128.053 35.382C127.381 36.138 127.059 37.006 127.059 38H133.947V36.656H128.949C129.159 36.11 129.803 35.48 130.881 34.766C131.875 34.094 132.561 33.562 132.953 33.156C133.597 32.442 133.933 31.658 133.933 30.79C133.933 29.908 133.625 29.194 133.023 28.634C132.407 28.074 131.609 27.808 130.657 27.808Z"
            fill="#799CF6"
          />
          <text x="200" y="61" fill="#8890FB">
            {step3[0]}
          </text>
          <text x="196" y="76" fill="#8890FB">
            {step3[1]}
          </text>
          <g>
            <circle cx="215" cy="33" r="11" fill="white" />
            <circle cx="215" cy="33" r="10.5" stroke="#A5AFFF" />
          </g>
          <path
            d="M214.601 27.808C213.621 27.808 212.823 28.074 212.207 28.634C211.549 29.194 211.185 29.964 211.101 30.958H212.599C212.655 30.342 212.865 29.88 213.201 29.572C213.537 29.264 214.013 29.11 214.615 29.11C215.203 29.11 215.665 29.236 215.973 29.516C216.253 29.782 216.407 30.16 216.407 30.664C216.407 31.168 216.239 31.56 215.931 31.826C215.623 32.092 215.161 32.232 214.545 32.232H213.831V33.38H214.559C215.217 33.38 215.721 33.52 216.057 33.8C216.421 34.08 216.603 34.514 216.603 35.102C216.603 35.606 216.421 36.012 216.085 36.348C215.693 36.712 215.175 36.908 214.531 36.908C213.943 36.908 213.467 36.74 213.103 36.404C212.683 36.04 212.473 35.522 212.445 34.85H210.905C210.989 35.97 211.381 36.824 212.081 37.412C212.697 37.93 213.523 38.196 214.545 38.196C215.609 38.196 216.491 37.888 217.163 37.3C217.793 36.712 218.115 35.956 218.115 35.032C218.115 34.444 217.947 33.954 217.611 33.576C217.303 33.212 216.855 32.932 216.267 32.75C217.359 32.386 217.919 31.644 217.919 30.552C217.919 29.698 217.611 29.026 217.023 28.536C216.407 28.046 215.609 27.808 214.601 27.808Z"
            fill="#8B8CFB"
          />
          <circle cx="15.5" cy="33.5" r="9.5" fill="#94D8FB" />
          <rect x="43" y="101" width="251" height="12" fill="url(#paint1_linear)" />
          <text x="66" y="135" fill="#FFA294">
            {step6[0]}
          </text>
          <text x="62" y="150" fill="#FFA294">
            {step6[1]}
          </text>
          <g>
            <circle cx="86" cy="107" r="11" fill="white" />
            <circle cx="86" cy="107" r="10.5" stroke="#FFBAB0" />
          </g>
          <path
            d="M85.6427 101.808C84.4947 101.808 83.5707 102.312 82.8987 103.334C82.2267 104.342 81.9047 105.658 81.9047 107.282C81.9047 108.808 82.2127 109.998 82.8287 110.852C83.4727 111.748 84.3967 112.196 85.6287 112.196C86.6087 112.196 87.4487 111.86 88.1207 111.216C88.7787 110.572 89.1147 109.746 89.1147 108.752C89.1147 107.772 88.8207 106.96 88.2467 106.33C87.6587 105.714 86.8747 105.406 85.8947 105.406C85.3627 105.406 84.9007 105.504 84.5087 105.714C84.0747 105.924 83.7247 106.246 83.4447 106.694H83.3887C83.3747 106.61 83.3747 106.554 83.3747 106.512C83.3747 105.532 83.5707 104.734 83.9767 104.09C84.3827 103.404 84.9287 103.068 85.6287 103.068C86.6367 103.068 87.2387 103.544 87.4487 104.524H88.9327C88.6807 102.704 87.5747 101.808 85.6427 101.808ZM85.5867 106.638C86.2027 106.638 86.7067 106.834 87.0707 107.226C87.4347 107.59 87.6167 108.108 87.6167 108.752C87.6167 109.382 87.4207 109.9 87.0427 110.32C86.6787 110.726 86.1887 110.936 85.5727 110.936C84.9707 110.936 84.4807 110.74 84.1167 110.348C83.7387 109.956 83.5567 109.438 83.5567 108.794C83.5567 108.136 83.7387 107.618 84.1027 107.226C84.4667 106.834 84.9567 106.638 85.5867 106.638Z"
            fill="#FFB690"
          />
          <text x="139" y="135" fill="#FF6484">
            {step5[0]}
          </text>
          <text x="139" y="150" fill="#FF6484">
            {step5[1]}
          </text>
          <g>
            <circle cx="169" cy="107" r="11" fill="white" />
            <circle cx="169" cy="107" r="10.5" stroke="#FF6484" />
          </g>
          <path
            d="M165.633 102.004L165.087 107.604H166.515C166.711 107.24 166.977 106.974 167.341 106.806C167.677 106.638 168.055 106.568 168.503 106.568C169.175 106.568 169.679 106.764 170.043 107.156C170.407 107.548 170.589 108.094 170.589 108.794C170.589 109.438 170.379 109.942 169.959 110.334C169.539 110.712 169.021 110.908 168.405 110.908C167.845 110.908 167.397 110.782 167.061 110.53C166.683 110.25 166.459 109.816 166.403 109.256H164.905C164.975 110.18 165.367 110.922 166.081 111.454C166.725 111.944 167.495 112.196 168.391 112.196C169.385 112.196 170.239 111.902 170.953 111.314C171.709 110.656 172.101 109.816 172.101 108.78C172.101 107.702 171.793 106.862 171.205 106.246C170.617 105.63 169.847 105.322 168.909 105.322C168.461 105.322 168.041 105.392 167.677 105.546C167.271 105.686 166.921 105.91 166.613 106.232H166.571L166.865 103.348H171.653V102.004H165.633Z"
            fill="#FF6484"
          />
          <text x="220" y="135" fill="#FF7AB2">
            {step4[0]}
          </text>
          <text x="220" y="150" fill="#FF7AB2">
            {step4[1]}
          </text>
          <g>
            <circle cx="253" cy="107" r="11" fill="white" />
            <circle cx="253" cy="107" r="10.5" stroke="#FFA3C9" />
          </g>
          <path
            d="M253.511 102.004L248.583 108.388V109.83H253.455V112H254.911V109.83H256.423V108.612H254.911V102.004H253.511ZM253.413 103.936H253.455V108.612H249.829L253.413 103.936Z"
            fill="#FF7AB2"
          />
          <rect x="43" y="174" width="121" height="12" fill="url(#paint2_linear)" />
          <path
            d="M180 178.268C181.333 179.038 181.333 180.962 180 181.732L163.5 191.258C162.167 192.028 160.5 191.066 160.5 189.526V170.474C160.5 168.934 162.167 167.972 163.5 168.742L180 178.268Z"
            fill="#1AD1C4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M337 70.5C337 93.9721 317.748 113 294 113V101C311.121 101 325 87.3447 325 70.5C325 53.6553 311.121 40 294 40V28C317.748 28 337 47.0279 337 70.5Z"
            fill="url(#paint3_linear)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 143.5C0 166.972 19.2518 186 43 186V174C25.8792 174 12 160.345 12 143.5C12 126.655 25.8792 113 43 113V101C19.2518 101 0 120.028 0 143.5Z"
            fill="url(#paint4_linear)"
          />
          <text x="89" y="209" fill="#2BD0BA">
            {step7[0]}
          </text>
          <text x="95" y="224" fill="#2BD0BA">
            {step7[1]}
          </text>
          <g>
            <circle cx="114" cy="181" r="11" fill="white" />
            <circle cx="114" cy="181" r="10.5" stroke="#8ADBD1" />
          </g>
          <path
            d="M110.579 176.004V177.39H115.759L112.133 186H113.757L117.299 177.236V176.004H110.579Z"
            fill="#2BD0BA"
          />
          <defs>
            <linearGradient id="paint0_linear" x1="13" y1="34" x2="281.78" y2="34" gradientUnits="userSpaceOnUse">
              <stop stopColor="#97E1FB" />
              <stop offset="0.501016" stopColor="#789AF5" />
              <stop offset="1" stopColor="#9884FF" />
            </linearGradient>
            <linearGradient id="paint1_linear" x1="43" y1="107" x2="296.624" y2="107" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFC08D" />
              <stop offset="0.501016" stopColor="#FF6484" />
              <stop offset="1" stopColor="#FF77B8" />
            </linearGradient>
            <linearGradient id="paint2_linear" x1="43" y1="180" x2="165.265" y2="180" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3CCFB0" />
              <stop offset="1" stopColor="#16D1C6" />
            </linearGradient>
            <linearGradient id="paint3_linear" x1="285.5" y1="35.5" x2="294" y2="103.5" gradientUnits="userSpaceOnUse">
              <stop stopColor="#9487FE" />
              <stop offset="0.899169" stopColor="#FF78B8" />
            </linearGradient>
            <linearGradient id="paint4_linear" x1="51.5" y1="108.5" x2="43" y2="176.5" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFBF8E" />
              <stop offset="0.899169" stopColor="#36D0B4" />
            </linearGradient>
          </defs>
          <image width="57" height="56" x="255" xlinkHref="/images/teachers/sun.png" />
          <image width="95" height="100" x="207" y="152" xlinkHref="/images/teachers/jfl.png" />
        </svg>
      ) : (
        <svg
          width="337"
          height="257"
          viewBox="0 0 337 257"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          className={classNames(styles.stepMobile, className)}
        >
          <ellipse cx="275.5" cy="249.5" rx="49.5" ry="7.5" fill="#A7DBEC" fillOpacity="0.17" />
          <path d="M13 28H280V40H13V28Z" fill="url(#paint0_linear)" />
          <text x="35" y="61" fill="#94D8FB">
            {step1[0]}
          </text>
          <text x="35" y="76" fill="#94D8FB">
            {step1[1]}
          </text>
          <g>
            <circle cx="49" cy="33" r="11" fill="white" />
            <circle cx="49" cy="33" r="10.5" stroke="#8CC6F9" />
          </g>
          <path
            d="M48.8906 28.004C48.5546 28.368 48.1346 28.69 47.6306 28.998C47.1266 29.278 46.6646 29.474 46.2166 29.586V31.098C47.1406 30.832 47.9106 30.412 48.5126 29.838V38H50.0386V28.004H48.8906Z"
            fill="#8CC6F9"
          />
          <text x="117" y="61" fill="#7A9FF6">
            {step2[0]}
          </text>
          <text x="117" y="76" fill="#7A9FF6">
            {step2[1]}
          </text>
          <g>
            <circle cx="131" cy="33" r="11" fill="white" />
            <circle cx="131" cy="33" r="10.5" stroke="#799CF6" />
          </g>
          <path
            d="M130.657 27.808C129.593 27.808 128.725 28.158 128.081 28.886C127.451 29.558 127.129 30.454 127.115 31.574H128.641C128.669 30.762 128.837 30.16 129.173 29.74C129.495 29.306 129.971 29.096 130.601 29.096C131.189 29.096 131.651 29.236 131.959 29.516C132.267 29.796 132.421 30.216 132.421 30.776C132.421 31.364 132.183 31.91 131.735 32.414C131.455 32.708 130.979 33.086 130.307 33.562C129.173 34.346 128.417 34.948 128.053 35.382C127.381 36.138 127.059 37.006 127.059 38H133.947V36.656H128.949C129.159 36.11 129.803 35.48 130.881 34.766C131.875 34.094 132.561 33.562 132.953 33.156C133.597 32.442 133.933 31.658 133.933 30.79C133.933 29.908 133.625 29.194 133.023 28.634C132.407 28.074 131.609 27.808 130.657 27.808Z"
            fill="#799CF6"
          />
          <text x="200" y="61" fill="#8890FB">
            {step3[0]}
          </text>
          <text x="200" y="76" fill="#8890FB">
            {step3[1]}
          </text>
          <g>
            <circle cx="215" cy="33" r="11" fill="white" />
            <circle cx="215" cy="33" r="10.5" stroke="#A5AFFF" />
          </g>
          <path
            d="M214.601 27.808C213.621 27.808 212.823 28.074 212.207 28.634C211.549 29.194 211.185 29.964 211.101 30.958H212.599C212.655 30.342 212.865 29.88 213.201 29.572C213.537 29.264 214.013 29.11 214.615 29.11C215.203 29.11 215.665 29.236 215.973 29.516C216.253 29.782 216.407 30.16 216.407 30.664C216.407 31.168 216.239 31.56 215.931 31.826C215.623 32.092 215.161 32.232 214.545 32.232H213.831V33.38H214.559C215.217 33.38 215.721 33.52 216.057 33.8C216.421 34.08 216.603 34.514 216.603 35.102C216.603 35.606 216.421 36.012 216.085 36.348C215.693 36.712 215.175 36.908 214.531 36.908C213.943 36.908 213.467 36.74 213.103 36.404C212.683 36.04 212.473 35.522 212.445 34.85H210.905C210.989 35.97 211.381 36.824 212.081 37.412C212.697 37.93 213.523 38.196 214.545 38.196C215.609 38.196 216.491 37.888 217.163 37.3C217.793 36.712 218.115 35.956 218.115 35.032C218.115 34.444 217.947 33.954 217.611 33.576C217.303 33.212 216.855 32.932 216.267 32.75C217.359 32.386 217.919 31.644 217.919 30.552C217.919 29.698 217.611 29.026 217.023 28.536C216.407 28.046 215.609 27.808 214.601 27.808Z"
            fill="#8B8CFB"
          />
          <circle cx="15.5" cy="33.5" r="9.5" fill="#94D8FB" />
          <rect x="43" y="101" width="251" height="12" fill="url(#paint1_linear)" />
          <text x="72" y="135" fill="#FFA294">
            {step6[0]}
          </text>
          <text x="72" y="150" fill="#FFA294">
            {step6[1]}
          </text>
          <g>
            <circle cx="86" cy="107" r="11" fill="white" />
            <circle cx="86" cy="107" r="10.5" stroke="#FFBAB0" />
          </g>
          <path
            d="M85.6427 101.808C84.4947 101.808 83.5707 102.312 82.8987 103.334C82.2267 104.342 81.9047 105.658 81.9047 107.282C81.9047 108.808 82.2127 109.998 82.8287 110.852C83.4727 111.748 84.3967 112.196 85.6287 112.196C86.6087 112.196 87.4487 111.86 88.1207 111.216C88.7787 110.572 89.1147 109.746 89.1147 108.752C89.1147 107.772 88.8207 106.96 88.2467 106.33C87.6587 105.714 86.8747 105.406 85.8947 105.406C85.3627 105.406 84.9007 105.504 84.5087 105.714C84.0747 105.924 83.7247 106.246 83.4447 106.694H83.3887C83.3747 106.61 83.3747 106.554 83.3747 106.512C83.3747 105.532 83.5707 104.734 83.9767 104.09C84.3827 103.404 84.9287 103.068 85.6287 103.068C86.6367 103.068 87.2387 103.544 87.4487 104.524H88.9327C88.6807 102.704 87.5747 101.808 85.6427 101.808ZM85.5867 106.638C86.2027 106.638 86.7067 106.834 87.0707 107.226C87.4347 107.59 87.6167 108.108 87.6167 108.752C87.6167 109.382 87.4207 109.9 87.0427 110.32C86.6787 110.726 86.1887 110.936 85.5727 110.936C84.9707 110.936 84.4807 110.74 84.1167 110.348C83.7387 109.956 83.5567 109.438 83.5567 108.794C83.5567 108.136 83.7387 107.618 84.1027 107.226C84.4667 106.834 84.9567 106.638 85.5867 106.638Z"
            fill="#FFB690"
          />
          <text x="155" y="135" fill="#FF6484">
            {step5[0]}
          </text>
          <text x="155" y="150" fill="#FF6484">
            {step5[1]}
          </text>
          <g>
            <circle cx="169" cy="107" r="11" fill="white" />
            <circle cx="169" cy="107" r="10.5" stroke="#FF6484" />
          </g>
          <path
            d="M165.633 102.004L165.087 107.604H166.515C166.711 107.24 166.977 106.974 167.341 106.806C167.677 106.638 168.055 106.568 168.503 106.568C169.175 106.568 169.679 106.764 170.043 107.156C170.407 107.548 170.589 108.094 170.589 108.794C170.589 109.438 170.379 109.942 169.959 110.334C169.539 110.712 169.021 110.908 168.405 110.908C167.845 110.908 167.397 110.782 167.061 110.53C166.683 110.25 166.459 109.816 166.403 109.256H164.905C164.975 110.18 165.367 110.922 166.081 111.454C166.725 111.944 167.495 112.196 168.391 112.196C169.385 112.196 170.239 111.902 170.953 111.314C171.709 110.656 172.101 109.816 172.101 108.78C172.101 107.702 171.793 106.862 171.205 106.246C170.617 105.63 169.847 105.322 168.909 105.322C168.461 105.322 168.041 105.392 167.677 105.546C167.271 105.686 166.921 105.91 166.613 106.232H166.571L166.865 103.348H171.653V102.004H165.633Z"
            fill="#FF6484"
          />
          <text x="238" y="135" fill="#FF7AB2">
            {step4[0]}
          </text>
          <text x="238" y="150" fill="#FF7AB2">
            {step4[1]}
          </text>
          <g>
            <circle cx="253" cy="107" r="11" fill="white" />
            <circle cx="253" cy="107" r="10.5" stroke="#FFA3C9" />
          </g>
          <path
            d="M253.511 102.004L248.583 108.388V109.83H253.455V112H254.911V109.83H256.423V108.612H254.911V102.004H253.511ZM253.413 103.936H253.455V108.612H249.829L253.413 103.936Z"
            fill="#FF7AB2"
          />
          <rect x="43" y="174" width="121" height="12" fill="url(#paint2_linear)" />
          <path
            d="M180 178.268C181.333 179.038 181.333 180.962 180 181.732L163.5 191.258C162.167 192.028 160.5 191.066 160.5 189.526V170.474C160.5 168.934 162.167 167.972 163.5 168.742L180 178.268Z"
            fill="#1AD1C4"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M337 70.5C337 93.9721 317.748 113 294 113V101C311.121 101 325 87.3447 325 70.5C325 53.6553 311.121 40 294 40V28C317.748 28 337 47.0279 337 70.5Z"
            fill="url(#paint3_linear)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 143.5C0 166.972 19.2518 186 43 186V174C25.8792 174 12 160.345 12 143.5C12 126.655 25.8792 113 43 113V101C19.2518 101 0 120.028 0 143.5Z"
            fill="url(#paint4_linear)"
          />
          <text x="85" y="209" fill="#2BD0BA">
            {step7[0]}
          </text>
          <text x="99" y="224" fill="#2BD0BA">
            {step7[1]}
          </text>
          <g>
            <circle cx="114" cy="181" r="11" fill="white" />
            <circle cx="114" cy="181" r="10.5" stroke="#8ADBD1" />
          </g>
          <path
            d="M110.579 176.004V177.39H115.759L112.133 186H113.757L117.299 177.236V176.004H110.579Z"
            fill="#2BD0BA"
          />
          <defs>
            <linearGradient id="paint0_linear" x1="13" y1="34" x2="281.78" y2="34" gradientUnits="userSpaceOnUse">
              <stop stopColor="#97E1FB" />
              <stop offset="0.501016" stopColor="#789AF5" />
              <stop offset="1" stopColor="#9884FF" />
            </linearGradient>
            <linearGradient id="paint1_linear" x1="43" y1="107" x2="296.624" y2="107" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFC08D" />
              <stop offset="0.501016" stopColor="#FF6484" />
              <stop offset="1" stopColor="#FF77B8" />
            </linearGradient>
            <linearGradient id="paint2_linear" x1="43" y1="180" x2="165.265" y2="180" gradientUnits="userSpaceOnUse">
              <stop stopColor="#3CCFB0" />
              <stop offset="1" stopColor="#16D1C6" />
            </linearGradient>
            <linearGradient id="paint3_linear" x1="285.5" y1="35.5" x2="294" y2="103.5" gradientUnits="userSpaceOnUse">
              <stop stopColor="#9487FE" />
              <stop offset="0.899169" stopColor="#FF78B8" />
            </linearGradient>
            <linearGradient id="paint4_linear" x1="51.5" y1="108.5" x2="43" y2="176.5" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FFBF8E" />
              <stop offset="0.899169" stopColor="#36D0B4" />
            </linearGradient>
          </defs>
          <image width="57" height="56" x="255" xlinkHref="/images/teachers/sun.png" />
          <image width="95" height="100" x="207" y="152" xlinkHref="/images/teachers/jfl.png" />
        </svg>
      )}
    </>
  );
});

StepMobile.displayName = 'StepMobile';

export default StepMobile;
